module.exports = __webpack_public_path__ + "img/img-3.c92135ac.webp";